import { render, staticRenderFns } from "./applymenu.vue?vue&type=template&id=20af6646&"
import script from "./applymenu.vue?vue&type=script&lang=js&"
export * from "./applymenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports